const SOCIAL_COUNT_FIELDS = ["likes_count", "thoughts_count", "ratings_count"];

export function normaliseArtworkSocialSummary(value) {
  if (!value || typeof value !== "object") {
    return null;
  }

  const hasSummary = SOCIAL_COUNT_FIELDS.some((field) => (
    Object.prototype.hasOwnProperty.call(value, field)
  ));
  if (!hasSummary) {
    return null;
  }

  return SOCIAL_COUNT_FIELDS.reduce((summary, field) => ({
    ...summary,
    [field]: Math.max(Number(value[field]) || 0, 0),
  }), {});
}

export function mergeArtworkSocialData(summary, viewerState) {
  if (!summary && !viewerState) {
    return null;
  }

  return {
    ...(summary ?? {}),
    ...(viewerState ?? {}),
  };
}
